import tmhRequest from '@/config/tmhRequest'

export default {
    searchEmployeePerformanceCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/employeeperformancereport/searchemployeeperformancereportcount',
            method: 'post',
            data: data,
        })
    },
    searchEmployeePerformanceByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/employeeperformancereport/searchemployeeperformancereportbypage',
            method: 'post',
            data: data,
        })
    },
    exportEmployeePerformance: function (data) {
        return tmhRequest({
            url: '/report/ispa/employeeperformancereport/exportemployeeperformancereport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/employeeperformance.js